import axios from 'axios';
import { showLoading, hideLoading, setLoaderLogo } from './loader';
//require('dotenv').config({ path: `.env.${process.env.NODE_ENV}` })

var api_URL = 'http://localhost:7001'
if (process.env.NODE_ENV === "development") {
  api_URL = 'http://localhost:7001'
}
else if (process.env.NODE_ENV === "production") {
  api_URL = 'https://apiclient.newworld.center'
}
const instance = axios.create({
  baseURL: api_URL
});

console.log(process.env.NODE_ENV);
const AUTH_TOKEN = "123" // ค่าเดิม ใช้ตอนยังไม่ login
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

// อ่าน token ที่ได้ตอน login (ระบบปัจจุบันเก็บไว้ที่ auth_token)
const getLoginToken = () => {
  try {
    const tk = localStorage.getItem('auth_token') || localStorage.getItem('token') || '';
    return tk && tk !== 'null' && tk !== 'undefined' ? tk : '';
  } catch (e) {
    return '';
  }
};

// ส่ง auth ให้ทุก api อัตโนมัติ: ถ้า login แล้ว และคำขอนั้นยังไม่มี "Bearer ..." -> ใส่ Bearer <auth_token>
// คำขอที่ตั้ง Authorization เองไว้แล้ว (เช่น Bearer langter ตอนอัปสลิป) จะไม่ถูกเขียนทับ
instance.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const current = config.headers.Authorization || config.headers.authorization;
  const hasBearer = typeof current === 'string' && /^Bearer\s+\S+/i.test(current) && !/^Bearer\s+(null|undefined)$/i.test(current);
  if (!hasBearer) {
    const tk = getLoginToken();
    if (tk) config.headers.Authorization = `Bearer ${tk}`;
  }
  return config;
});

// ---- หน้าโหลดโลโก้: ขึ้นเฉพาะ API ที่เกิดจากการกดปุ่มทำรายการ (ไม่ขึ้นตอนดึงข้อมูลเบื้องหลัง) ----
const LOADING_APIS = [
  'userlogin', 'register', 'resetpassword', 'checkuseradvice',
  'userwithdraw', 'userwithdrawcancel', 'updateslip', 'getqrcode', 'redeemtrue',
  'redeempromotion', 'usercancelpromotion', 'usercoupon', 'cliamcashout', 'cliaminvite', 'userredeemrank',
  'postcheckinlist', 'tablauncher', 'tablauncherlotto',
];
const needLoading = (url) => {
  const m = String(url || '').match(/\/api\/v1\/([a-zA-Z0-9_]+)/);
  return !!(m && LOADING_APIS.includes(m[1]));
};
instance.interceptors.request.use((config) => {
  if (config && config.loading !== false && (config.loading === true || needLoading(config.url))) {
    config.__btLoading = true;
    showLoading();
  }
  return config;
});
instance.interceptors.response.use((res) => {
  if (res && res.config && res.config.__btLoading) hideLoading();
  // จำโลโก้เว็บจาก mainsetting ไว้ใช้ในหน้าโหลด
  try {
    if (/\/mainsetting/.test(res.config.url || '')) {
      const logo = res.data && res.data.tblsetting && res.data.tblsetting[0] && res.data.tblsetting[0].imglogo;
      if (logo) setLoaderLogo(logo);
    }
  } catch (e) { /* ignore */ }
  return res;
}, (err) => {
  if (err && err.config && err.config.__btLoading) hideLoading();
  return Promise.reject(err);
});

export default instance;
